import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CondenserGlyph = /*#__PURE__*/createElement("g", {
  id: "condenser"
}, /*#__PURE__*/createElement("path", {
  d: "M40.35 30.24H22.46v-1.36c0-1.5 1.21-2.71 2.71-2.71h12.47c1.5 0 2.71 1.21 2.71 2.71v1.36zm21.46 0H43.92v-1.36c0-1.5 1.21-2.71 2.71-2.71H59.1c1.5 0 2.71 1.21 2.71 2.71v1.36z"
}), /*#__PURE__*/createElement("path", {
  d: "M67.8 49.71H16.2c-.83 0-1.5-.67-1.5-1.5V31.02c0-.83.67-1.5 1.5-1.5h51.6c.83 0 1.5.67 1.5 1.5v17.19c0 .83-.67 1.5-1.5 1.5zm-50.1-3h48.6V32.52H17.7v14.19z"
}), /*#__PURE__*/createElement("path", {
  d: "M21.93 57.04c-.34.43-1.07.78-1.62.78H20c-.55 0-.93-.44-.85-.99l1.05-6.73c.08-.54.6-.99 1.15-.99h5.86c.55 0 .72.35.38.78l-5.66 7.15zm40.23 0c.34.43 1.07.78 1.62.78h.3c.55 0 .93-.44.85-.99l-1.05-6.73c-.08-.54-.6-.99-1.15-.99h-5.86c-.55 0-.72.35-.38.78l5.67 7.15z"
}));
const Condenser = createSvg({
  name: 'condenser',
  path: CondenserGlyph
});

export default Condenser;
export { CondenserGlyph };
